import { Input } from '@breetometer/components';
import { CURRENCYCONFIG } from 'BreetHelpers';
import { type ChangeEvent, memo, type MouseEvent, useCallback } from 'react';

import type { FiatInputComponentProps } from '../FiatInput.helpers';

export const FiatInputComponent = memo(
	({ id, value, currencyCode, loading, onChange, handleError, ...rest }: FiatInputComponentProps) => {
		const handleInputValue = useCallback(
			(e: ChangeEvent<HTMLInputElement>) => {
				onChange?.(e);

				handleError?.(e);
			},
			[onChange, handleError]
		);

		const onInputClick = useCallback(
			(e: MouseEvent<HTMLInputElement>) => {
				if (String(value) === '0') {
					e.currentTarget.select();
				}
			},
			[value]
		);

		const currency = CURRENCYCONFIG[currencyCode].symbol;
		return (
			<>
				{!loading ? (
					<>
						<label
							htmlFor={id}
							className='fiat_input_component_wrapper_label color-neutral-50'
						>
							{currency}
						</label>
						<Input
							className='fiat_input_component theme-border-none'
							id=''
							label=''
							{...rest}
							onChange={handleInputValue}
							onClick={onInputClick}
							value={value}
							autoComplete='off'
							inputMode='numeric'
							pattern='^\d{1,3}(,\d{3})*(\.\d{0,2})?$'
						/>
					</>
				) : (
					<span className='global-skeleton'>loading...</span>
				)}
			</>
		);
	}
);

FiatInputComponent.displayName = 'FiatInputComponent';
